"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ContactGroupMemberModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            contactGroupId: 'McLabs2__Group__c',
            contactId: 'McLabs2__Contact__c'
        };
    }
    transformFromSalesforce(sfContactGroupMember) {
        super.transformFromSalesforce(sfContactGroupMember);
        this.contact = new _1.ContactModel(sfContactGroupMember.McLabs2__Contact__r, 'transformFromSalesforce');
    }
}
exports.ContactGroupMemberModel = ContactGroupMemberModel;
//# sourceMappingURL=contact-group-member.model.js.map